import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable } from 'rxjs';

import { accountSelectors, type AppState } from '@blaze-shared/app-state-data-access';

@Injectable()
export class IsAccountInitializedGuard {
  private readonly store = inject<Store<AppState>>(Store);

  canLoad(): Observable<boolean> {
    return this.store.select(accountSelectors.selectIsInitialized).pipe(filter(Boolean));
  }
}
